import React, { useEffect } from 'react';
import Navbar from '../components/layout/Navbar';
import Footer from '../components/layout/Footer';
import BackButton from '../components/common/BackButton';

const PrivacyPolicy = () => {
  const currentDate = new Date().toLocaleDateString('en-IN', { 
    year: 'numeric', 
    month: 'long', 
    day: 'numeric' 
  });

  // Scroll to top on mount
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  return (
    <div className="min-h-screen bg-gray-50">
      <Navbar />
      <div className="pt-24 pb-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-white rounded-2xl shadow-lg p-8 md:p-12">
            <BackButton />
            <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
              Privacy Policy
            </h1>
            <p className="text-gray-600 mb-8" style={{ fontSize: '14px' }}>
              Last Updated: {currentDate}
            </p>

            <div className="prose prose-lg max-w-none space-y-6">
              <section>
                <h2 className="text-2xl font-bold text-gray-900 mb-4" style={{ fontSize: '18px' }}>
                  Introduction
                </h2>
                <p className="text-gray-800 leading-relaxed mb-4" style={{ fontSize: '14px' }}>
                  We, <strong>Prajwal Jadhav and Nikita Bansod / Shravi Finance</strong> (Individual DSA), collect minimal personal information such as name, phone number, email, city, loan amount, and income range to connect you with RBI-regulated banks/NBFCs.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-gray-900 mb-4" style={{ fontSize: '18px' }}>
                  Data Usage
                </h2>
                <ul className="list-disc list-inside space-y-2 text-gray-800" style={{ fontSize: '14px' }}>
                  <li>Shared only with 2–3 relevant partner lenders (SBI, HDFC Bank, Bajaj Finserv, etc.)</li>
                  <li>Used solely for loan offers/pre-approval</li>
                  <li>Not sold, rented, or shared with marketers</li>
                  <li>Deleted within 30 days if not required</li>
                </ul>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-gray-900 mb-4" style={{ fontSize: '18px' }}>
                  Your Rights (DPDP Act, 2023)
                </h2>
                <ul className="list-disc list-inside space-y-2 text-gray-800" style={{ fontSize: '14px' }}>
                  <li><strong>Right to Access:</strong> Request access to your personal data we hold</li>
                  <li><strong>Right to Correction:</strong> Request correction of inaccurate or incomplete data</li>
                  <li><strong>Right to Deletion:</strong> Request deletion of your personal data</li>
                  <li><strong>Right to Withdraw Consent:</strong> Withdraw consent anytime for data processing</li>
                  <li><strong>Right to Grievance:</strong> Lodge complaints regarding data processing</li>
                </ul>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-gray-900 mb-4" style={{ fontSize: '18px' }}>
                  Security Measures
                </h2>
                <ul className="list-disc list-inside space-y-2 text-gray-800" style={{ fontSize: '14px' }}>
                  <li>HTTPS encryption for data transmission</li>
                  <li>Secure storage of personal information</li>
                  <li>Limited internal access on need-to-know basis</li>
                  <li>Regular security audits and updates</li>
                </ul>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-gray-900 mb-4" style={{ fontSize: '18px' }}>
                  Compliance
                </h2>
                <p className="text-gray-800 leading-relaxed mb-3" style={{ fontSize: '14px' }}>
                  We are compliant with:
                </p>
                <ul className="list-disc list-inside space-y-2 text-gray-800" style={{ fontSize: '14px' }}>
                  <li>RBI Digital Lending Guidelines</li>
                  <li>Information Technology Act, 2000</li>
                  <li>DPDP Act, 2023 (Digital Personal Data Protection Act)</li>
                  <li>RBI Fair Practices Code</li>
                </ul>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-gray-900 mb-4" style={{ fontSize: '18px' }}>
                  Contact Us
                </h2>
                <p className="text-gray-800 leading-relaxed mb-3" style={{ fontSize: '14px' }}>
                  For any privacy-related queries or to exercise your rights, please contact us:
                </p>
                <div className="bg-gray-50 p-4 rounded-lg" style={{ fontSize: '14px' }}>
                  <p className="text-gray-800 mb-2">
                    <strong>Email:</strong> <a href="mailto:shravifinance@gmail.com" className="text-primary-600 hover:underline">shravifinance@gmail.com</a>
                  </p>
                  <p className="text-gray-800 mb-2">
                    <strong>Phone:</strong> <a href="tel:+918668272248" className="text-primary-600 hover:underline">+91 8668272248</a> / <a href="tel:+917020113728" className="text-primary-600 hover:underline">+91 7020113728</a>
                  </p>
                  <p className="text-gray-800">
                    <strong>Working Hours:</strong> 10:30 AM – 7:00 PM (IST)
                  </p>
                </div>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-gray-900 mb-4" style={{ fontSize: '18px' }}>
                  Changes to This Policy
                </h2>
                <p className="text-gray-800 leading-relaxed" style={{ fontSize: '14px' }}>
                  We may update this Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page and updating the "Last Updated" date.
                </p>
              </section>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default PrivacyPolicy;

